import React from 'react';

const QuestionArea = ({ currentQ, handleOptionSelect }) => {
    return (
        <div className="flex-1 flex flex-col gap-2">
            <div className="flex justify-between items-center">
                <h3 className="text-[16px] tracking-tight font-[500] text-gray-800">Question {currentQ.id} of 100</h3>
            </div>

            <p className="text-[16px] text-gray-800 font-medium leading-tight mb-2">
                {currentQ.text}
            </p>

            <div className="space-y-4">
                {currentQ.options.map((opt) => (
                    <div
                        key={opt.id}
                        onClick={() => handleOptionSelect(opt.id)}
                        className={`flex items-center gap-4 p-2 rounded-md text-[#818183] border-[1.5px] cursor-pointer transition-all 
                            ${currentQ.selectedOption === opt.id 
                                ? "bg-[#FFCFCF] border-[#E63946]" 
                                : "border-[#818183] text-[#818183]"}`}
                    >
                        <span className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm
                            ${currentQ.selectedOption === opt.id ? "bg-[#E63946] text-white" : "bg-[#EFEFEF] text-[#818183]"}`}>
                            {opt.id}
                        </span>
                        <span className="text-[15px] tracking-tight text-[#33333399] font-[500]">{opt.text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuestionArea;